import { OfferResponseWithStatus } from 'app/api/@generated/backend';

import { OfferService } from 'app/pages/order/services/offer-service';
import {
    selectSelectedAccountOrThrow,
    selectSelectedServiceLocationOrThrow,
} from 'app/pages/order/redux/order-selector';
import { createAppAsyncThunk } from 'app/redux/utils/thunk-utils';
import { RequestType } from 'app/pages/order/redux/model/order-request';

export const fetchBroadbandOfferActionCreator = createAppAsyncThunk<OfferResponseWithStatus>(
    'order/fetchBroadbandOffer',
    async (_, { getState }) => {
        const rootState = getState();

        const selectedAccount = selectSelectedAccountOrThrow(rootState);
        const { customerId, partnerId } = selectedAccount;
        const serviceLocation = selectSelectedServiceLocationOrThrow(rootState);
        const { integrationId } = serviceLocation;

        return OfferService.getCurrentBroadbandOffer(partnerId, customerId, integrationId);
    },
    {
        getPendingMeta: () => ({ requestType: RequestType.GET_BROADBAND_OFFER }),
    },
);
